"use strict";

export function initInScope ($scope) {
    $scope.find('.js-select-with-href').on('change',function (e) {
        let href = $(this).find(':selected').attr('data-href');
        window.location.href = href;
    });
}
